/* ===========================================================
   lib/words.js — Casual words vs Developer words

   Casual mode never says branch, commit or diff. Developer mode uses
   the Git-style names people in that world expect. w('key') picks
   the right one for the current mode.
   =========================================================== */

import { mode } from '../state.js';

const W = {
  history: ['Version history', 'History'],
  saveVersion: ['Save a version', 'Commit'],
  saveVersionHint: ['Give this moment a name so it\'s easy to find later.', 'Snapshot the current state with a message.'],
  versionName: ['Name this version', 'Commit message'],
  versionNamePlaceholder: ['e.g. "First draft" or "Before big changes"', 'e.g. "Rewrite intro"'],
  version: ['version', 'commit'],
  versions: ['versions', 'commits'],
  named: ['Named versions', 'Named commits'],
  auto: ['Saved automatically', 'auto-commit'],
  restore: ['Restore this version', 'Restore (checkout) this commit'],
  restored: ['Restored', 'Restored commit'],
  preview: ['Preview', 'View'],
  compare: ['Compare', 'Diff'],
  compareNow: ['Compare with now', 'Diff against HEAD'],
  tryCopy: ['Try an edit on a copy', 'New branch'],
  tryCopyHint: ['Make a private copy to try changes. When you like them, merge them back.', 'Branch off the current state. Merge back when ready.'],
  copy: ['edit copy', 'branch'],
  copies: ['Edit copies', 'Branches'],
  mergeBack: ['Merge changes back', 'Merge into original'],
  original: ['Original', 'Base (original)'],
  conflicts: ['spots changed in both', 'conflicts'],
  conflict: ['spot changed in both', 'conflict'],
  now: ['Now', 'HEAD'],
};

export function w(key) {
  const pair = W[key];
  if (!pair) return key;
  return pair[mode.value === 'dev' ? 1 : 0];
}
